import { FC, ReactElement, useRef } from 'react';

import classNames from 'classnames';
import { NavLink } from 'react-router-dom';

import { Navigation } from '../../../../entities/@navigation/Navigation/Navigation';
import { useDocumentCssVariable, useElementSize, useTrans } from '../../../../hooks';
import { NavLinkClassName } from '../../../../types';

import './DesktopSubNavigation.scss';

interface DesktopSubNavigationProps {
    subNavigation: Navigation;
    className?: string;
}

export const DesktopSubNavigation: FC<DesktopSubNavigationProps> = ({
    subNavigation,
    className = '',
}): ReactElement => {
    const trans = useTrans();

    const subNavigationRef = useRef<HTMLDivElement>(null);

    const { height } = useElementSize(subNavigationRef);

    useDocumentCssVariable('--submenu-height', `${height}px`);

    return (
        <nav
            ref={subNavigationRef}
            aria-label={trans('containers.menu.subNavigation')}
            className={`desktop-sub-navigation ${className}`}
        >
            <ul className="desktop-sub-navigation__group-list">
                {subNavigation.groups.map(group => (
                    <li key={group.id}>
                        <ul className="desktop-sub-navigation__item-list">
                            {group.items.map(item => {
                                const navLinkClassNames: NavLinkClassName = ({ isActive }): string => classNames('desktop-sub-navigation__link', {
                                    'desktop-sub-navigation__link--is-active': isActive,
                                });

                                if (item.hideDesktop) {
                                    return null;
                                }

                                return (
                                    <li key={item.id} className="desktop-sub-navigation__item">
                                        <NavLink to={item.to} className={navLinkClassNames}>
                                            {item.label}
                                        </NavLink>
                                    </li>
                                );
                            })}
                        </ul>
                    </li>
                ))}
            </ul>
        </nav>
    );
};
